import React from 'react';
import { Box, Button, ListItemIcon, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const AddDataPointButton = ({
  MultipleDataPointsPerSession,
  dataPointPerSession,
  handleAddDataPoint,
}) => {
  return (
    <>
      <Button
        disabled={
          (MultipleDataPointsPerSession || dataPointPerSession) !== 'Yes'
        }
        variant='outlined'
        sx={{ mt: 2 }}
        onClick={handleAddDataPoint}
      >
        + Add Data Point
      </Button>

      {(MultipleDataPointsPerSession || dataPointPerSession) !== 'Yes' && (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <ListItemIcon>
            <InfoIcon
              fontSize='small'
              sx={{ color: 'var(--clr-theme-black)', mr: 0.5 }}
            />
            <Typography variant='body2' color='var(--clr-mindly-black)'>
              Edit the goal to allow add data points.
            </Typography>
          </ListItemIcon>
        </Box>
      )}
    </>
  );
};

export default AddDataPointButton;